import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfSubHomeGaleriaSchema } from './schema';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque os campos
 * Imagem e Destino de cada item abrem o navegador de conteúdo de dentro de um
 * `object_list`.
 *
 * Sem `dataAdapter` próprio (o bloco não tem autofill: a imagem é escolhida à
 * mão e a legenda é opcional), então o `onChangeField` cai no gravar direto —
 * o mesmo fallback que os demais blocos usam quando o registro não declara um.
 */
const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfSubHomeGaleriaSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        dataAdapter({ block, data, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
